"use client";

import NavigationBar from "../components/NavBar";
import Card from "../components/Card";
import styles from "../styles/home.module.css"
import { useNavigate, useParams } from "react-router-dom";
import flatInfo from "../data/FlatInfo";
import GoogleMapComponent from "../components/Map";
import { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"];

export default function SearchListings(){

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API,
    libraries,
  });

  const [selectedFlat, setSelectedFlat] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 23.8103, lng: 90.4125 }); // Default: Dhaka
  const [filteredFlats, setFilteredFlats] = useState(flatInfo);
  const [priceRange, setPriceRange] = useState("all");
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  // 1) Put your scroll listener here, but keep it simple
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 2) If not loaded, bail out
  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  // 3) Now define the helper functions OUTSIDE the effect:

  const filterNearbyFlats = (lat, lng) => {
    const R = 6371; // Radius of Earth in km
    const toRad = (value) => (value * Math.PI) / 180;

    const filtered = flatInfo.filter((flat) => {
      const dLat = toRad(flat.latitude - lat);
      const dLng = toRad(flat.longitude - lng);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat)) *
          Math.cos(toRad(flat.latitude)) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in km
      return distance <= 100000; // Show flats within 100,000 km? (Check your logic)
    });

    setFilteredFlats(filtered);
    applyPriceFilter(filtered);
  };

  const applyPriceFilter = (flats) => {
    let filtered = flats;

    if (priceRange !== "all") {
      const [min, max] = priceRange.split("-").map(Number);
      filtered = flats.filter((flat) => {
        const price = flat.costBreakdown.main.monthly.required[0].value;
        return price >= min && price <= max;
      });
    } else if (priceRange === "All Prices") {
      filtered = flatInfo;
    }

    setFilteredFlats(filtered);
  };

  const handlePriceChange = (e) => {
    setPriceRange(e.target.value);
    applyPriceFilter(flatInfo);
  };

  // 4) Then do your return:
  return (
    <>
      <NavigationBar/>
      <div className={`${styles.FilterContainer} ${isScrolled ? styles.scrolledFilter : ""}`}>
        <SearchBar setMapCenter={setMapCenter} filterNearbyFlats={filterNearbyFlats} />
        <select className={styles.PriceFilter} value={priceRange} onChange={handlePriceChange}>
          <option value="all">All Prices</option>
          <option value="0-10000">৳0 - ৳10,000</option>
          <option value="10000-20000">৳10,000 - ৳20,000</option>
          <option value="20000-50000">৳20,000 - ৳50,000</option>
          <option value="50000-100000">৳50,000 - ৳100,000</option>
          <option value="100000-1000000">৳100,000+</option>
        </select>
      </div>

      <div className={styles.ListingContent}>
        <div className={styles.Map}>
          <GoogleMapComponent onSelectFlat={setSelectedFlat} mapCenter={mapCenter}/>
        </div>
        
        <div className={styles.Cards}>
          {selectedFlat && (
            <>
              <div style={{
                display: "flex", 
                alignItems: "center", 
                gap: "10px", 
                backgroundColor: "#fdf0ac", 
                padding: "5px", 
                borderRadius: "5px"
              }}>
                <h3 style={{ color: "#0041D9", fontFamily: "Poppins", margin: 0 }}>
                  Selected Flat
                </h3>
                <button
                  onClick={() => setSelectedFlat(null)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#0041D9",
                    marginLeft: "15px"
                  }}
                >
                  ❌
                </button>
              </div>
              <div className={styles.selectedCard}>
                <div className={styles.card}>
                  <Card flat={selectedFlat} />
                </div>
              </div>
            </>
          )}

          {filteredFlats.map((item, index) => (
            <div key={index}>
              <Card flat={item} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
